var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column", staticStyle: { gap: "0.5rem" } },
    [
      _c("div", { ref: "container", staticClass: "acknowledgement-consent" }, [
        _c("div", { ref: "agreementData", on: { scroll: _vm.onScroll } }, [
          _c("p", [
            _vm._v(
              "Flash Money Pty Ltd, A.B.N 71 619 737 656, Australian Credit License 508661. I understand that by completing\n        an application form that Flash Money Pty Ltd (the entity) will collect, use, hold and disclose my information\n        as outlined in the Privacy Policy, which I declare that I have read and understood."
            ),
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("Collection of information")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        I consent to the entity collecting personal and credit information from me. I understand that if I do not\n        provide all information that is requested from me the entity may be unable to provide me with their financial\n        services. I also understand that if any of my personal information should change, such as residential address,\n        phone number, email address, etc., it is my responsibility to advise the entity of this. I understand it may\n        not always be practical or reasonable to collect information from me and as such, I provide my consent for the\n        entity to collect personal information about me on an ongoing basis from:\n      "
            ),
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "If any of these parties should request this Acknowledgement and Consent before providing information, I\n        consent for this to be provided to them."
            ),
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("Use of information")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "I consent to the entity collecting my information for the purposes of providing me with financial services\n        and any related purpose including but not limited to:\n\n        lending activities including accepting and assessing loan applications and disbursement of credit;\n\n        credit management functions relating to the management of accounts and collection of overdue amounts; customer\n        service requests such as providing access to and updating personal information and resolving disputes;\n        gathering information and statistical data to analyze and evaluate business functions;\n\n        developing our service offerings and improving overall business processes and efficiency.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("Disclosure of information")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "I consent to the entity disclosing my personal information to provide me with their financial services and\n        any other related purpose as outlined above, on an ongoing basis to:"
            ),
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "I understand my information may also be disclosed in other circumstances outlined in the entity's privacy\n        policy."
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "I understand the entity may, in the ordinary course of our business, disclose my credit information to third\n        parties which operate in the United States of America and while these parties may not, therefore, be subject\n        to Australian Privacy Law, no person in those countries will be able to access my credit eligibility\n        information without my express consent."
            ),
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("Promotion of Products and Services")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "I consent to being contacted by the entity, and any external third parties or agents who act on their behalf,\n        for the purposes of the promotion of products and services. I understand the entity may promote the products\n        of their marketing partners. I understand that I may withdraw my consent and request not to receive\n        promotional communications at any time by contacting the entity."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { ref: "scrollTarget" },
          [
            _c(
              "TransitionGroup",
              {
                staticClass: "d-block",
                attrs: { mode: "out-in", name: "slide-fade", tag: "div" },
              },
              [
                !_vm.done
                  ? _c(
                      "div",
                      {
                        key: "see-more",
                        staticClass:
                          "d-flex justify-content-center align-items-center p-3 see-more",
                        on: { click: _vm.scrollBy },
                      },
                      [
                        _c("span", [_vm._v("See More")]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass: "bi bi-arrow-down-short",
                            attrs: {
                              fill: "currentColor",
                              height: "24",
                              viewBox: "0 0 16 16",
                              width: "24",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z",
                                "fill-rule": "evenodd",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _c("Checkbox", {
                      key: "acknowledgement-checkbox",
                      staticClass:
                        "m-0 d-flex align-items-center acknowledgement-checkbox",
                      staticStyle: { width: "100%" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ onClick, style }) {
                            return [
                              _c(
                                "div",
                                { style: style, on: { click: onClick } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex flex-column",
                                      staticStyle: { gap: "0.5rem" },
                                    },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { cursor: "pointer" } },
                                        [
                                          _vm._v(
                                            "I have read, understood and agree with Flash Money's\n                  Acknowledgement and Consent."
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "/docs/Acknowledgement and Consent.pdf",
                                            target: "_blank",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Get a copy of consent\n                  document."
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.proxyValue,
                        callback: function ($$v) {
                          _vm.proxyValue = $$v
                        },
                        expression: "proxyValue",
                      },
                    }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "ac-hint" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "12",
              height: "12",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              "aria-hidden": "true",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
              },
            }),
          ]
        ),
        _vm._v("\n    Read to the bottom to enable acknowledgement.\n  "),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", { attrs: { type: "i" } }, [
      _c("li", [
        _vm._v("publicly available sources such as public registers;"),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("credit reporting bodies;")]),
      _vm._v(" "),
      _c("li", [_vm._v("employers or income providers;")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("other financial service providers and financial institutions;"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", { attrs: { type: "i" } }, [
      _c("li", [_vm._v("my personal point of contacts,")]),
      _vm._v(" "),
      _c("li", [_vm._v("my employers and income providers;")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("other financial institutions and debt collection agencies;"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "credit providers, credit brokers, other referrers and other service providers. Financiers, insurers,\n          auditors, contractors, agents or service providers the entity uses to offer services;\n        "
        ),
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("any other entity.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }